export default __webpack_public_path__ + "static/media/weightlossregime_3.dc98a8e2.jpg";